/**
 * Built-in desktop apps — shown in the Electron system bar launcher.
 *
 * Each app opens in a new tab. Apps with `needsHub` inherit the hub of the tab
 * they are launched from (the tab auto-connects to it before showing the app).
 *
 * `label` carries both languages (the bar and the settings list pick with `tt`);
 * the native shell is handed the picked word by `ShellApp.vue`, so the Electron
 * tab titles follow the same table.
 */
import type { Bilingual } from './bilingual';

export interface BuiltinApp {
  id: string;
  label: Bilingual;
  /** Material Symbols icon name. */
  icon: string;
  /** Route inside the app the tab navigates to. */
  route: string;
  needsHub: boolean;
  /** Entry exists but the app is not available yet. */
  comingSoon?: boolean;
}

export const BUILTIN_APPS: BuiltinApp[] = [
  {
    id: 'player',
    label: { en: 'Player', sl: 'Predvajalnik' },
    icon: 'play_circle',
    route: '/player',
    needsHub: true,
  },
  {
    id: 'panel',
    label: { en: 'Panel', sl: 'Plošča' },
    icon: 'grid_view',
    route: '/panel',
    needsHub: true,
  },
  {
    id: 'pos',
    label: { en: 'POS', sl: 'POS' },
    icon: 'point_of_sale',
    route: '/pos',
    needsHub: true,
    comingSoon: true,
  },
  {
    // Service browser: the cloud marketplace, browsable without a hub (a guest
    // can look around; contacting a business needs a signed-in account).
    id: 'services',
    label: { en: 'Services', sl: 'Storitve' },
    icon: 'apps',
    route: '/services',
    needsHub: false,
  },
];

export function getBuiltinApp(id: string): BuiltinApp | undefined {
  return BUILTIN_APPS.find((app) => app.id === id);
}
